var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.id)?_c('router-view'):_c('List')],1)}
var staticRenderFns = []

export { render, staticRenderFns }